// !!!!CAUTION!!!! THIS LINE SHOULD BE THE FIRST ONE
// EVEN IMPORT SHOULD GO AFTER THIS LINE OTHERWISE
// WEBPACK WILL NOT LOAD THE BUNDLES FROM THE RIGHT LOCATION
__webpack_public_path__ = window.PUBLIC_PATH;
__webpack_nonce__ = window.__webpack_nonce__;

const loadApp = () => {
    switch (window.EXPLORE_APP_MODE) {
        case 'chart':
            void import(/* webpackChunkName: "chart" */ './chart');
            break;
        case 'portal':
            void import(/* webpackChunkName: "portal" */ './portal');
            break;
        case 'studio':
            void import(/* webpackChunkName: "studio" */ './studio');
            break;
        case 'viewer':
            void import(/* webpackChunkName: "viewer" */ './viewer');
            break;
        default:
            throw new Error(`application mode not compatible${window.EXPLORE_APP_MODE as any}`);
    }
};

/* eslint-disable */
(async () => {
    const fallbackLocale = 'en-us';
    try {
        const response = await fetch(
            `${window.TRANSLATIONS_FOLDER_URL}${window.EXPLORE_LANGUAGE}.json`
        );

        if (response.ok) {
            window.EXPLORE_LOCALES = await response.json();
        } else {
            const fallback = await fetch(`${window.TRANSLATIONS_FOLDER_URL}${fallbackLocale}.json`);

            if (fallback.ok) {
                window.EXPLORE_LANGUAGE = fallbackLocale;
                window.EXPLORE_LOCALES = await fallback.json();
            } else {
                throw new Error('Unable to load all translations');
            }
        }

        loadApp();
    } catch (e: any) {
        // eslint-disable-next-line no-console
        console.error(`An error occurred while loading Explore: ${e.message}`);
    }
})();
